<div class="post-image-grid">
  <!-- One media case -->
  @if (media.length === 1) {
    <div
      class="container-single-image"
      [class.video-playoverlay]="media[0].type === 'video' && !autoplay"
      [class.portrait]="isFirstTall"
  [class.landscape]="!isFirstTall"
  [class.large]="isLargeEnough"
      (click)="showGallery(media[0])"
      >
      @if (!autoplay) {
        @if (media[0].preview || media[0].path) {
          <img
            [ngSrc]="media[0].preview ? media[0].preview! : media[0].path!"
            [width]="media[0].width"
            [height]="media[0].height"
            [sizes]="'100vw'"
            [alt]="media[0].filename"
            [disableOptimizedSrcset]="media[0].mimetype === 'image/gif'"
            priority
            />
        }
      }
      @if (autoplay) {
        <video autoplay loop [muted]="true">
          <source [fileName]="media[0].path" type="video/mp4" src="" appVideoSrc />
          @if (media[0].preview || media[0].path) {
            <img [ngSrc]="media[0].preview ? media[0].preview! : media[0].path!" [width]="media[0].width" [height]="media[0].height" [sizes]="'100vw'" [alt]="media[0].filename" priority />
          }
        </video>
      }
    </div>
  }

  <!-- Two media case -->
  @if (media.length === 2) {
    <div class="container-two-images" [class.portrait]="isFirstTall">
      <div class="img-wrapper" [class.video-playoverlay]="media[0].type === 'video'" (click)="showGallery(media[0])">
        @if (media[0].preview || media[0].path) {
          <img [ngSrc]="media[0].preview ? media[0].preview! : media[0].path!" [width]="media[0].width" [height]="media[0].height" [sizes]="'100vw'" [alt]="media[0].filename" [disableOptimizedSrcset]="media[0].mimetype === 'image/gif'" priority/>
        }
      </div>
      <div class="img-wrapper" [class.video-playoverlay]="media[1].type === 'video'" (click)="showGallery(media[1])">
        @if (media[1].preview || media[1].path) {
          <img [ngSrc]="media[1].preview ? media[1].preview! : media[1].path!" [width]="media[1].width" [height]="media[1].height" [sizes]="'100vw'" [alt]="media[1].filename" [disableOptimizedSrcset]="media[1].mimetype === 'image/gif'" priority/>
        }
      </div>
    </div>
  }

  <!-- Three media case -->
  @if (media.length === 3) {
    <div class="container-three-images" [class.first-portrait]="isFirstTall" [class.first-landscape]="!isFirstTall">
      <!-- First Image (Left Column or Top Row) -->
      @if (isFirstTall) {
        <div class="img-wrapper portrait" [class.video-playoverlay]="media[0].type === 'video'" (click)="showGallery(media[0])">
          @if (media[0].preview || media[0].path) {
            <img [ngSrc]="media[0].preview ? media[0].preview! : media[0].path!" [width]="media[0].width" [height]="media[0].height" [sizes]="'100vw'" [alt]="media[0].filename" [disableOptimizedSrcset]="media[0].mimetype === 'image/gif'" priority />
          }
        </div>
      }
      @if (!isFirstTall) {
        <div class="img-wrapper landscape" [class.video-playoverlay]="media[0].type === 'video'" (click)="showGallery(media[0])">
          @if (media[0].preview || media[0].path) {
            <img [ngSrc]="media[0].preview ? media[0].preview! : media[0].path!" [width]="media[0].width" [height]="media[0].height" [sizes]="'100vw'" [alt]="media[0].filename" [disableOptimizedSrcset]="media[0].mimetype === 'image/gif'" priority />
          }
        </div>
      }
      <!-- Second & Third Images -->
      <div class="img-group">
        <div class="img-wrapper second" [class.video-playoverlay]="media[1].type === 'video'" (click)="showGallery(media[1])">
          @if (media[1].preview || media[1].path) {
            <img [ngSrc]="media[1].preview ? media[1].preview! : media[1].path!" [width]="media[1].width" [height]="media[1].height" [sizes]="'100vw'" [alt]="media[1].filename" [disableOptimizedSrcset]="media[1].mimetype === 'image/gif'" priority />
          }
        </div>
        <div class="img-wrapper third" [class.video-playoverlay]="media[2].type === 'video'" (click)="showGallery(media[2])">
          @if (media[2].preview || media[2].path) {
            <img [ngSrc]="media[2].preview ? media[2].preview! : media[2].path!" [width]="media[2].width" [height]="media[2].height" [sizes]="'100vw'" [alt]="media[2].filename" [disableOptimizedSrcset]="media[2].mimetype === 'image/gif'" priority />
          }
        </div>
      </div>
    </div>
  }

  <!-- Four media case -->
  @if (media.length === 4) {
    <div class="container-four-images" [class.first-portrait]="isFirstTall" [class.first-landscape]="!isFirstTall">
      <!-- First Image (Portrait: Left Column, Landscape: Top Row) -->
      @if (isFirstTall) {
        <div class="img-wrapper portrait" [class.video-playoverlay]="media[0].type === 'video'" (click)="showGallery(media[0])">
          @if (media[0].preview || media[0].path) {
            <img [ngSrc]="media[0].preview ? media[0].preview! : media[0].path!" [width]="media[0].width" [height]="media[0].height" [sizes]="'100vw'" [alt]="media[0].filename" [disableOptimizedSrcset]="media[0].mimetype === 'image/gif'" priority />
          }
        </div>
      }
      @if (!isFirstTall) {
        <div class="img-wrapper landscape" [class.video-playoverlay]="media[0].type === 'video'" (click)="showGallery(media[0])">
          @if (media[0].preview || media[0].path) {
            <img [ngSrc]="media[0].preview ? media[0].preview! : media[0].path!" [width]="media[0].width" [height]="media[0].height" [sizes]="'100vw'" [alt]="media[0].filename" [disableOptimizedSrcset]="media[0].mimetype === 'image/gif'" priority />
          }
        </div>
      }
      <!-- Right Column for Portrait (Stacked) -->
      @if (isFirstTall) {
        <div class="img-group">
          <div class="img-wrapper top" [class.video-playoverlay]="media[1].type === 'video'" (click)="showGallery(media[1])">
            @if (media[1].preview || media[1].path) {
              <img [ngSrc]="media[1].preview ? media[1].preview! : media[1].path!" [width]="media[1].width" [height]="media[1].height" [sizes]="'100vw'" [alt]="media[1].filename" [disableOptimizedSrcset]="media[1].mimetype === 'image/gif'" priority />
            }
          </div>
          <div class="bottom-group">
            <div class="img-wrapper" [class.video-playoverlay]="media[2].type === 'video'" (click)="showGallery(media[2])">
              @if (media[2].preview || media[2].path) {
                <img [ngSrc]="media[2].preview ? media[2].preview! : media[2].path!" [width]="media[2].width" [height]="media[2].height" [sizes]="'100vw'" [alt]="media[2].filename" [disableOptimizedSrcset]="media[2].mimetype === 'image/gif'" priority />
              }
            </div>
            <div class="img-wrapper" [class.video-playoverlay]="media[3].type === 'video'" (click)="showGallery(media[3])">
              @if (media[3].preview || media[3].path) {
                <img [ngSrc]="media[3].preview ? media[3].preview! : media[3].path!" [width]="media[3].width" [height]="media[3].height" [sizes]="'100vw'" [alt]="media[3].filename" [disableOptimizedSrcset]="media[3].mimetype === 'image/gif'" priority />
              }
            </div>
          </div>
        </div>
      }
      <!-- Bottom Row for Landscape (3 Equal Columns) -->
      @if (!isFirstTall) {
        <div class="img-group">
          <div class="img-wrapper" [class.video-playoverlay]="media[1].type === 'video'" (click)="showGallery(media[1])">
            @if (media[1].preview || media[1].path) {
              <img [ngSrc]="media[1].preview ? media[1].preview! : media[1].path!" [width]="media[1].width" [height]="media[1].height" [sizes]="'100vw'" [alt]="media[1].filename" [disableOptimizedSrcset]="media[1].mimetype === 'image/gif'" priority />
            }
          </div>
          <div class="img-wrapper" [class.video-playoverlay]="media[2].type === 'video'" (click)="showGallery(media[2])">
            @if (media[2].preview || media[2].path) {
              <img [ngSrc]="media[2].preview ? media[2].preview! : media[2].path!" [width]="media[2].width" [height]="media[2].height" [sizes]="'100vw'" [alt]="media[2].filename" [disableOptimizedSrcset]="media[2].mimetype === 'image/gif'" priority />
            }
          </div>
          <div class="img-wrapper" [class.video-playoverlay]="media[3].type === 'video'" (click)="showGallery(media[3])">
            @if (media[3].preview || media[3].path) {
              <img [ngSrc]="media[3].preview ? media[3].preview! : media[3].path!" [width]="media[3].width" [height]="media[3].height" [sizes]="'100vw'" [alt]="media[3].filename" [disableOptimizedSrcset]="media[3].mimetype === 'image/gif'" priority />
            }
          </div>
        </div>
      }
    </div>
  }

  <!-- Five media case -->
  @if (media.length === 5) {
    <div class="container-five-images">
      <!-- Top Row (Two Images, 60% Height) -->
      <div class="top-row">
        <div class="img-wrapper" [class.video-playoverlay]="media[0].type === 'video'" (click)="showGallery(media[0])">
          @if (media[0].preview || media[0].path) {
            <img [ngSrc]="media[0].preview ? media[0].preview! : media[0].path!" [width]="media[0].width" [height]="media[0].height" [sizes]="'100vw'" [alt]="media[0].filename" [disableOptimizedSrcset]="media[0].mimetype === 'image/gif'" priority/>
          }
        </div>
        <div class="img-wrapper" [class.video-playoverlay]="media[1].type === 'video'" (click)="showGallery(media[1])">
          @if (media[1].preview || media[1].path) {
            <img [ngSrc]="media[1].preview ? media[1].preview! : media[1].path!" [width]="media[1].width" [height]="media[1].height" [sizes]="'100vw'" [alt]="media[1].filename" [disableOptimizedSrcset]="media[1].mimetype === 'image/gif'" priority/>
          }
        </div>
      </div>
      <!-- Bottom Row (Three Images, 40% Height) -->
      <div class="bottom-row">
        <div class="img-wrapper" [class.video-playoverlay]="media[2].type === 'video'" (click)="showGallery(media[2])">
          @if (media[2].preview || media[2].path) {
            <img [ngSrc]="media[2].preview ? media[2].preview! : media[2].path!" [width]="media[2].width" [height]="media[2].height" [sizes]="'100vw'" [alt]="media[2].filename" [disableOptimizedSrcset]="media[2].mimetype === 'image/gif'" priority/>
          }
        </div>
        <div class="img-wrapper" [class.video-playoverlay]="media[3].type === 'video'" (click)="showGallery(media[3])">
          @if (media[3].preview || media[3].path) {
            <img [ngSrc]="media[3].preview ? media[3].preview! : media[3].path!" [width]="media[3].width" [height]="media[3].height" [sizes]="'100vw'" [alt]="media[3].filename" [disableOptimizedSrcset]="media[3].mimetype === 'image/gif'" priority/>
          }
        </div>
        <div class="img-wrapper" [class.video-playoverlay]="media[4].type === 'video'" (click)="showGallery(media[4])">
          @if (media[4].preview || media[4].path) {
            <img [ngSrc]="media[4].preview ? media[4].preview! : media[4].path!" [width]="media[4].width" [height]="media[4].height" [sizes]="'100vw'" [alt]="media[4].filename" [disableOptimizedSrcset]="media[4].mimetype === 'image/gif'" priority/>
          }
        </div>
      </div>
    </div>
  }

  <!-- More than five media -->
  @if (media.length > 5) {
    <div class="container-more-images">
      <!-- Top Row (Two Images, 60% Height) -->
      <div class="top-row">
        <div class="img-wrapper" [class.video-playoverlay]="media[0].type === 'video'" (click)="showGallery(media[0])">
          @if (media[0].preview || media[0].path) {
            <img [ngSrc]="media[0].preview ? media[0].preview! : media[0].path!" [width]="media[0].width" [height]="media[0].height" [sizes]="'100vw'" [alt]="media[0].filename" [disableOptimizedSrcset]="media[0].mimetype === 'image/gif'" priority/>
          }
        </div>
        <div class="img-wrapper" [class.video-playoverlay]="media[1].type === 'video'" (click)="showGallery(media[1])">
          @if (media[1].preview || media[1].path) {
            <img [ngSrc]="media[1].preview ? media[1].preview! : media[1].path!" [width]="media[1].width" [height]="media[1].height" [sizes]="'100vw'" [alt]="media[1].filename" [disableOptimizedSrcset]="media[1].mimetype === 'image/gif'" priority/>
          }
        </div>
      </div>
      <!-- Bottom Row (Three Images, 40% Height) -->
      <div class="bottom-row">
        <div class="img-wrapper" [class.video-playoverlay]="media[2].type === 'video'" (click)="showGallery(media[2])">
          @if (media[2].preview || media[2].path) {
            <img [ngSrc]="media[2].preview ? media[2].preview! : media[2].path!" [width]="media[2].width" [height]="media[2].height" [sizes]="'100vw'" [alt]="media[2].filename" [disableOptimizedSrcset]="media[2].mimetype === 'image/gif'" priority/>
          }
        </div>
        <div class="img-wrapper" [class.video-playoverlay]="media[3].type === 'video'" (click)="showGallery(media[3])">
          @if (media[3].preview || media[3].path) {
            <img [ngSrc]="media[3].preview ? media[3].preview! : media[3].path!" [width]="media[3].width" [height]="media[3].height" [sizes]="'100vw'" [alt]="media[3].filename" [disableOptimizedSrcset]="media[3].mimetype === 'image/gif'" priority/>
          }
        </div>
        <div class="img-wrapper cursor-pointer" [class.video-playoverlay]="media[4].type === 'video'" [attr.data-overlay]="'+' + (media.length - 5)" (click)="showGallery(media[4])">
          @if (media[4].preview || media[4].path) {
            <img [ngSrc]="media[4].preview ? media[4].preview! : media[4].path!" [width]="media[4].width" [height]="media[4].height" [sizes]="'100vw'" [alt]="media[4].filename" [disableOptimizedSrcset]="media[4].mimetype === 'image/gif'" priority/>
          }
        </div>
      </div>
    </div>
  }
</div>
